import { BASE_URL, TIME_OUT } from "./config";
import SHRequest from "./request";
const shRequest = new SHRequest({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  responseType: "blob",
});
export default shRequest;
